// to check / think about
// -
import moment from 'moment';

let version = '1.9.10';

//--------------------------------------------------------------------------
// ######## Remember to update the life expectancy assumptions  ########
//--------------------------------------------------------------------------

let assumptions = {
    inflation: 0.03,
    tv_investment_returns: 0.015,
    tv_post_unreduced_erf: 0.03,
    dd_investment_returns: 0.0325,
    dd_annual_cost: 750
};

let taxCalcParams = {
    personalAllowance: 12570,
    basicRateLimit: 37700,
    basicRate: 0.2,
    higherRateLimit: 150000,
    higherRate: 0.4,
    additionalRate: 0.45,
    personalAllowanceReducedFrom: 100000,
    personalAllowanceReducedRate: 0.5
};

let gmpLRF = 0.0743;

let bsp = 9175.4;
let lta = 1073100;

let lifeexpectancy = {
    "F_S": [[86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91],[87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91],[87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,92],[87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92],[87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92],[87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92,92],[87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92,92,92],[87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92,92,92,92],[87,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92,92,92,92,92],[88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92,92,92,92,92,92],[88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91,91,91,91,91,91,91,92,92,92,92,92,92,92,92]],
    "F_I": [[85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90],[85,85,85,85,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90],[85,85,85,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90],[85,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91],[86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91],[86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91],[86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91],[86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91,91]],
    "M_S": [[85,85,85,85,85,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90],[85,85,85,85,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90],[85,85,85,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90],[85,86,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90],[86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,91],[86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,91,91],[86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,91,91,91],[86,86,86,87,87,87,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,89,89,89,89,89,89,89,89,89,89,90,90,90,90,90,90,90,90,90,90,90,91,91,91,91]],
    "M_I": [[83,83,83,83,83,83,83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88],[83,83,83,83,83,83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,88,88,88],[83,83,83,83,83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,88,88,88,88],[83,83,83,83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88],[83,83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88],[83,83,83,83,83,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88],[83,83,83,84,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88],[84,84,84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88],[84,84,84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88],[84,84,84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88],[84,84,84,84,84,84,84,85,85,85,85,85,85,85,85,85,85,85,85,85,86,86,86,86,86,86,86,86,86,87,87,87,87,87,87,87,87,87,87,88,88,88,88,88,88,88,88,88,88,88,89]]
};
// 54 to 64 and 1950 to 2000 yob
let lifeexpectancy_age_min = 54;
let lifeexpectancy_age_max = 64;
let lifeexpectancy_yob_min = 1950;

let market_annuities = [27.0563,26.9687,26.2398,25.8131,25.3872,24.8447,24.3546,23.7643,23.1267,22.4972,21.8579];

// let annuity_key ={
//     "sl_level_none": 0,
//     "sl_level_chronic": 1,
//     "sl_level_smoker": 2,
//     "sl_level_chronicsmoker": 3,
//     "sl_rpi_none": 4,
//     "sl_rpi_chronic": 5,
//     "sl_rpi_smoker": 6,
//     "sl_rpi_chronicsmoker": 7,
//     "joint_level_none": 8,
//     "joint_level_chronic": 9,
//     "joint_level_smoker": 10,
//     "joint_level_chronicsmoker": 11,
//     "joint_rpi_none": 12,
//     "joint_rpi_chronic": 13,
//     "joint_rpi_smoker": 14,
//     "joint_rpi_chronicsmoker": 15
// };
let market_annuities_min = 55;
let market_annuities_max = 65;



let spa_M = [65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.000,65.175,65.258,65.348,65.433,65.518,65.600,65.682,65.764,65.847,65.934,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.083,66.167,66.250,66.333,66.417,66.500,66.583,66.667,66.750,66.833,66.917,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.014,67.096,67.184,67.266,67.348,67.427,67.510,67.595,67.679,67.762,67.852,67.929,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000];
let spa_F = [60.000,60.000,60.000,60.000,60.014,60.096,60.184,60.266,60.348,60.427,60.510,60.595,60.679,60.762,60.852,60.932,61.014,61.096,61.184,61.266,61.348,61.427,61.510,61.595,61.679,61.762,61.852,61.929,62.014,62.096,62.184,62.266,62.348,62.427,62.510,62.595,62.679,62.762,62.852,62.932,63.181,63.433,63.679,63.929,64.181,64.427,64.677,64.932,65.175,65.258,65.348,65.433,65.518,65.600,65.682,65.764,65.847,65.934,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.000,66.083,66.167,66.250,66.333,66.417,66.500,66.583,66.667,66.750,66.833,66.917,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.000,67.014,67.096,67.184,67.266,67.348,67.427,67.510,67.595,67.679,67.762,67.852,67.929,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000,68.000];
let spa_min = 23400;
let spa_max = 23760;
// 54 to 70
let Factor_A1 = [1,0.958,0.918,0.881,0.845,0.812,0.781,0.751,0.722,0.695,0.67];
let Factor_A1_min = 0;
let Factor_A1_max = 10;

let Factor_A_Late = [1,1.051,1.106,1.166,1.231,1.303];
let Factor_A_Late_min = 0;
let Factor_A_Late_max = 5;
// 0 to 10
let Factor_A2 = [1,0.941,0.887,0.838,0.793,0.751,0.713,0.677,0.644,0.613,0.584,0.557,0.532,0.508,0.487,0.467,0.448,0.430];
let Factor_A2_min = 0;
let Factor_A2_max = 17;
// 0 to 17
let Factor_B = [31.12,30.54,29.96,29.38,28.79,28.20,27.61,27.01,26.40,25.79,25.18,24.55,23.92,23.29,22.65,22.00,21.35,20.70,20.05,19.41,18.76,18.12,17.47,16.83,16.18,15.53,14.88,14.23,13.58,12.94,12.31];
let Factor_B_min = 45;
let Factor_B_max = 75;


// 45 to 75

let get_annuity = function (retAge) {
    // let key = spouse? 'joint_' : 'sl_' ;
    // key += increasing? 'rpi_' : 'level_';

    // let healthKey = "none";
    // if (smoker && chronic) {
    //     healthKey = "chronicsmoker";
    // } else {
    //     if (smoker) healthKey = "smoker";
    //     if (chronic) healthKey = "chronic";
    // }
    // key += healthKey;

    let annuity_factor = get_factor(market_annuities, market_annuities_min, market_annuities_max, retAge);

    return annuity_factor;
};

let get_TV = function (user) {

    if (Number.isNaN(user.date_of_transfer_value_guarantee)) return user.transfer_value

    if(user.today < user.date_of_transfer_value_guarantee) return user.transfer_value;

    return user.notional_transfer_value_;
}

let dob_months = function (dob) {
    return dob.year()*12 + dob.month();
};

let caclculateTax = function (amount) {
    let pa = taxCalcParams.personalAllowance - Math.min(Math.max(amount - taxCalcParams.personalAllowanceReducedFrom, 0)*taxCalcParams.personalAllowanceReducedRate,taxCalcParams.personalAllowance);

    let basicRateTax = Math.max(Math.min(amount - pa, taxCalcParams.basicRateLimit),0) * taxCalcParams.basicRate;
    let higherRateTax = Math.max(Math.min(amount - pa - taxCalcParams.basicRateLimit, taxCalcParams.higherRateLimit - taxCalcParams.basicRateLimit), 0) * taxCalcParams.higherRate;
    let additionalRateTax = Math.max(amount - pa - taxCalcParams.higherRateLimit, 0) * taxCalcParams.additionalRate;

    return basicRateTax + higherRateTax + additionalRateTax;
};

let y_days = function (date1, date2) {
    var d1, d2;
    if (date1 >= date2){
        d1 = date1.clone(); d2 = date2.clone();
    } else {
        d1 = date2.clone(); d2 = date1.clone();
    }

    let yrs = d1.diff(d2, 'years');
    let days = d1.diff(d2.add(yrs, 'years'), 'days')/365;

    return yrs + days;
};

let interpolate = function (array, min, max, value) {
    if (value < min) value = min;
    if (value > max) value = max;

    let factor = array[0] + (array[1] - array[0]) * (value - min) / (max - min);
    return factor;
};


let get_factor = function (array, min, max, value) {
    if (value < min) value = min;
    if (value > max) value = max;

    let floor = Math.floor(value);
    let ceil = Math.ceil(value);

    let factorFloor = array[floor - min];
    let factorCeil = array[ceil - min];

    let factor = factorFloor + (factorCeil - factorFloor) * (value - floor);

    return factor;
};

let calculate_immediate_revalued_deferred_pension = function (user) {
    // let dol = user.date_of_leaving.year() + user.date_of_leaving.month()/12;
    // let doc = user.calculation_date.year() + user.calculation_date.month()/12;
    //let infRev = get_inflation_term(dol, doc);

    let rf = retirement_factors(user.sex, user.age, user.age, user.earliest_undreduced_retirement_age);

    return user.total_revalued_deferred_pension_to_current_calculation_date * rf.rf_ret_age * (1 - user.redundancy_factor/100);

    // if (user.earliest_undreduced_retirement_age - user.age <= 0) {
    //     let erf_term = Math.max(user.earliest_undreduced_retirement_age - user.age, 0);
    //     let erf = get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, erf_term);

    //     return user.total_revalued_deferred_pension_to_current_calculation_date * erf * (1 - user.redundancy_factor/100);
    // } else {
    //     let lrf_term = Math.min(Math.max(user.age - user.earliest_undreduced_retirement_age, 0), 5);
    //     let lrf = get_factor(Factor_A_Late, Factor_A_Late_min, Factor_A_Late_max, lrf_term);

    //     return user.total_revalued_deferred_pension_to_current_calculation_date * lrf * (1 - user.redundancy_factor/100);
    // }
};

/*

    let erf_term = Math.max(earliest_undreduced_retirement_age - retirement_age, 0);
    let erf_pen_term = Math.max(earliest_undreduced_retirement_age - pension_age, 0);
    let erf = get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, erf_term);
    let erf_pen = get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, erf_pen_term);
*/

let retirement_factors = function (gender, age_pen, retirement_age, earliest_undreduced_retirement_age) {
    let term_ret = earliest_undreduced_retirement_age - retirement_age;
    let pen_term = earliest_undreduced_retirement_age - age_pen;
    let rf_ret = term_ret >= 0 ?
        get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, Math.max(term_ret,0)) :
        get_factor(Factor_A_Late, Factor_A_Late_min, Factor_A_Late_max,  Math.max(-term_ret,0))
    let rf_pen = pen_term >= 0 ?
        get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, Math.max(pen_term, 0)) :
        get_factor(Factor_A_Late, Factor_A_Late_min, Factor_A_Late_max,  Math.max(-pen_term,0))

    let rf_65 = 65 - earliest_undreduced_retirement_age > 0 ?
        get_factor(Factor_A_Late, Factor_A_Late_min, Factor_A_Late_max, 65 - earliest_undreduced_retirement_age) :
        get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, earliest_undreduced_retirement_age - 65);

    let rf_60 = get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, Math.max(earliest_undreduced_retirement_age - 60, 0));

    return {
        rf_ret_age: rf_ret,
        rf_pen_age: rf_pen,
        rf_60: rf_60,
        rf_65: rf_65,
        rf_gmp: gender == 'M' ?  rf_65 : rf_60
    };
};

let calculate_deferred_pension = function (gender, pension, pension_age, retirement_age, earliest_undreduced_retirement_age) {

    let rfs = retirement_factors(gender, pension_age, retirement_age, earliest_undreduced_retirement_age);
    // let reval = Math.pow((1+assumptions.inflation), retirement_age - pension_age);
    let retirement_pension = pension * rfs.rf_ret_age / rfs.rf_pen_age;

    return retirement_pension;
};

let calculate_immediate_pension_active = function (user) {

    //apply early retirement factor to current pension
    let erf_term = Math.max(user.earliest_undreduced_retirement_age - user.age, 0);
    let erf = get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, erf_term);

    return user.total_deferred_pension_at_dol * erf;
};

let initialiseUser = function (user) {

    //mapping
    user.sex = user.gender__m_f_;
    user.calculation_date = user.current_calculation_date;
    user.immediate_pension = user.total_pension_at_current_retirement_date__no_levelling_option_;
    user.immediate_sp_pension = user.spouses_pension_at_crd__no_levelling_option_;
    user.immediate_pre88_gmp = user.notional___crystalised_pre_88_gmp_at_crd;
    user.immediate_post88_gmp = user.notional___crystalised_post_88_gmp_at_crd;
    user.immediate_xs_gmp = user.non_gmp_pension_at_current_retirement_date___no_levelling_option_;
    // user.pension_at_60 = user.pension_at_60;
    // user.pension_at_65 = user.pension_at_65;
    user.mp_avcs_value = Number.isNaN(user.value_of_avc1) ? 0 : user.value_of_avc1;
    user.pre_88_gmp_at_dol = user.pre_88_gmp__inc_tv_in_gmp_;
    user.post_88_gmp_at_dol = user.post_88_gmp__inc_tv_in_gmp_;

    user.status = user.member_status.toLowerCase();

    user.early_retirement_without_reduction = user.unreduced_pension_date__earliest_date_member_can_take_benefit_with_no_reduction_for_early_payment_;
    user.early_retirement_with_reduction = user.earliest_date_member_can_take_benefit_with_reduction_for_early_payment;
    user.age = y_days(user.calculation_date, user.date_of_birth);
    user.today = moment(new Date());
    user.ageNow = y_days(user.today, user.date_of_birth);
    user.yob = user.date_of_birth.year();

    if (user.status == 'deferred') {
        user.normal_retirement_date = user.unreduced_pension_date__earliest_date_member_can_take_benefit_with_no_reduction_for_early_payment_;
    }

    user.joined = y_days(user.date_joined_scheme, user.date_of_birth);
    user.earliest_retirement_date = user.normal_retirement_date;
    user.earliest_unreduced_retirement_date = user.normal_retirement_date;
    //Active - Early Retirement Without Reduction               Early Retirement With Reduction
    //Deferred - Early Retirement With Reduction Early Retirement Date without Reduction
    if (user.early_retirement_with_reduction) user.earliest_retirement_date = moment.min(user.earliest_retirement_date, user.earliest_date_member_can_take_benefit_with_reduction_for_early_payment);
    if (user.early_retirement_without_reduction) user.earliest_retirement_date = moment.min(user.earliest_retirement_date, user.early_retirement_without_reduction);
    if (user.early_retirement_without_reduction) user.earliest_unreduced_retirement_date = moment.min(user.earliest_unreduced_retirement_date, user.early_retirement_without_reduction);
    user.earliest_retirement_age = user.earliest_retirement_date.diff(user.date_of_birth, 'months') / 12;
    user.earliest_undreduced_retirement_age = user.earliest_unreduced_retirement_date.diff(user.date_of_birth, 'months') / 12;
    user.nra = user.normal_retirement_date.diff(user.date_of_birth, 'months') / 12;

    let rfs = retirement_factors(user.sex, user.age, user.earliest_undreduced_retirement_age, user.earliest_undreduced_retirement_age);

    if (user.age > 60) {
        user.pension_at_60 = user.immediate_pension;
    }

    user.immediate_pension_unred = user.immediate_pension / rfs.rf_pen_age;
    user.pension_at_60_unred = user.pension_at_60 / (user.age > 60? rfs.rf_pen_age : rfs.rf_60);
    user.pension_at_65_unred = user.pension_at_65 / (user.age > 65? rfs.rf_pen_age : rfs.rf_65);


    user.restricted_group = null;
    user.canRetireFrom = user.earliest_retirement_age;

    let service = {
        ageJoined: user.joined,
        ageLeft: user.status == 'deferred'? y_days(user.date_of_leaving, user.date_of_birth) : null
    };

    user.servicePeriods = [];
    user.servicePeriods.push(service);

    //change to use spreadsheet codes.

    //user.eligibility_based_on_age = user.over_nrd == "Y" ? "Y" : user.eligibility_based_on_age;
    // user.over_nrd = user.over_nrd == "Y" ? "Y" : "N";
    user.eligibility_based_on_age = user.eligibility_based_on_age == "Y" ? "Y" : "N";
    user.redundancy = user.earliest_undreduced_retirement_age < 55? "Y" : "N";
    user.redundancy_factor = user.__reduction_for_pensions_due_to_redundancy_from_50;

    if (user.eligibility_based_on_age == "Y" && user.exclusion_marker == "N" && user.multiple_periods_of_service == "N" ) {
        //
        user.type = "full";

        if (user.immediate_pension == 0) {
            //need to calculate immediate pension
            user.immediate_pension = user.status == 'deferred'? calculate_immediate_revalued_deferred_pension(user) : calculate_immediate_pension_active(user);
            user.immediate_pension_unred = user.immediate_pension / rfs.rf_pen_age;
        }

        if (user.immediate_sp_pension == 0) {
            let sp_prop = 2/3;
            user.immediate_sp_pension = user.immediate_pension_unred * sp_prop /  (1 - user.redundancy_factor/100);
        }

        if (user.status == 'deferred') {
            //add in 60 and 65 pensions
            user.pension_at_60 = calculate_deferred_pension(user.sex, user.immediate_pension, user.age, Math.max(60, user.age), user.earliest_undreduced_retirement_age);
            user.pension_at_60_unred = user.pension_at_60 / (user.age > 60? rfs.rf_pen_age : rfs.rf_60);
            user.pension_at_65 = calculate_deferred_pension(user.sex, user.immediate_pension, user.age, 65, user.earliest_undreduced_retirement_age);
            user.pension_at_65_unred = user.pension_at_65 / (user.age > 65? rfs.rf_pen_age : rfs.rf_65);
            let date_86 = moment([1986,0,1]);
            user.pre86 = false;
            if (user.date_of_leaving < date_86){
                user.pre86 = true;
            }
        }

        user.spouse_pension_on_did = user.total_spouses_pension_at_doL;

        user.transfer_value_use = get_TV(user);

        user.high_tv = user.transfer_value_use > (lta * 0.8);


    } else if (user.eligibility_based_on_age != "Y") {
        user.type = "age_restricted";
        return user;
    } else {
        user.type = "special_case";
        return user;
    }

    return user;
};

let getProjectedTV = function (state) {
    // let doc = state.user.calculation_date;
    let retAge = state.retirementAge;
    // let dor = state.user.date_of_birth.clone().add(retAge, 'years');
    // let term = y_days(doc, dor);
    let ageNow = state.user.age;
    let rfs = retirement_factors(state.user.sex, ageNow, retAge, state.user.earliest_undreduced_retirement_age);

    // For actives
    // let termPostUnreduced = state.user.status == 'deferred'? 0 : Math.max(retAge - Math.max(state.user.earliest_undreduced_retirement_age, state.user.age), 0);

    let retirement_pension = (retAge <=60 ?
        interpolate([state.user.immediate_pension_unred, state.user.pension_at_60_unred] , ageNow, 60, retAge) :
        interpolate([state.user.pension_at_60_unred, state.user.pension_at_65_unred], Math.max(ageNow, 60), 65, retAge));

    let projected_tv =  state.user.transfer_value_use * retirement_pension / (state.user.immediate_pension / rfs.rf_pen_age);

    return state.user.mp_avcs_value + projected_tv ; // * Math.pow((1+assumptions.tv_investment_returns)/(1+assumptions.inflation), term) * Math.pow(1 + assumptions.tv_post_unreduced_erf, -termPostUnreduced);
};

let getDrawdownAnnuity = function (retAge, dd_age) {
    let t = Math.max(dd_age - retAge, 0);
    let i_real = (1+assumptions.dd_investment_returns) / (1 + assumptions.inflation) -1;
    return (1-Math.pow(1 + i_real, -t)) / i_real;
};

let weeksFromAgeToAge = function (age1, age2) {
    let weeks =Math.floor((age2-age1)*365/7,0)+1;
    return weeks;
}

const pensionFn = {
    getERFac: function (undreduced_age, age) {
        let erf_term = Math.max(undreduced_age - age, 0);
        let erf = get_factor(Factor_A1, Factor_A1_min, Factor_A1_max, erf_term);
        return erf;
    },
    getCommutationFac: function (age) {
        let com = get_factor(Factor_B, Factor_B_min, Factor_B_max, age);
        return com;
    },
    getSchemeCalc: function (state, cashProp, bridgeTheGap) {
        if (!state.user) return null;

        let sex = state.user.sex;
        let retAge = state.retirementAge;
        let nra = state.user.nra;
        let dor = state.user.date_of_birth.clone().add(retAge, 'years');
        let ageNow = state.user.age;
        let rfs = retirement_factors(state.user.sex, ageNow, retAge, state.user.earliest_undreduced_retirement_age);
        let gmp_age = state.user.sex == "M"? 65 : 60;
        let gmp_date = state.user.date_of_birth.clone().add(gmp_age, 'years');

        let nra_retirement_pension = state.user.immediate_pension_unred;
            // (nra <=60 ?
            // interpolate([state.user.immediate_pension_unred, state.user.pension_at_60_unred], ageNow, 60, nra) :
            // interpolate([state.user.pension_at_60_unred, state.user.pension_at_65_unred], Math.max(ageNow, 60), 65, nra)) * (nra <= 60? erfs.erf_60 : erfs.erf_65);

        // i should be interpolating no-er numbers and then applying factors

        let mp_avcs = state.user.mp_avcs_value;
        let gmp_dol = state.user.status == 'deferred' ? state.user.pre_88_gmp_at_dol + state.user.post_88_gmp_at_dol : 0;

        let retirement_pension = 0;
        let gmp_dor = 0;
        let gmp_step_up = 0;
        let gmp_step_up_at_gmp_age = 0;

        if (retAge > gmp_age && ageNow < gmp_age) {

            if (state.user.status == 'deferred' ) {
                let retirement_pension_at_gmp_age = (gmp_age <=60 ?
                    interpolate([state.user.immediate_pension_unred, state.user.pension_at_60_unred], ageNow, 60, gmp_age) :
                    interpolate([state.user.pension_at_60_unred, state.user.pension_at_65_unred], Math.max(ageNow, 60), 65, gmp_age)) * rfs.rf_gmp;

                let gmp_gmpDate = state.user.pre_6_april_1988_guaranteed_minimum_pension_at_gmp_age_inc_tv_in_gmp + state.user.post_5_april_1988_guaranteed_minimum_pension_at_gmp_age_inc_tv_in_gmp;
                let notional_increases = Math.pow(1+assumptions.inflation,  y_days(state.user.calculation_date, gmp_date));
                // if (state.user.pre86) {
                //     gmp_step_up =Math.max(Math.max(gmp_gmpDate - retirement_pension*notional_increases) / notional_increases,0);
                // } else {

                // }
                let notional_gmp_gmpDate = gmp_dol * (retirement_pension_at_gmp_age / Math.min(rfs.rf_ret_age, 1)) / (state.user.total_deferred_pension_at_dol) * notional_increases;

                // let gmp_gmpDateReal = gmp_gmpDate / notional_increases;
                gmp_step_up =Math.max(Math.max(gmp_gmpDate - notional_gmp_gmpDate) / notional_increases,0);

                // Today's money

                retirement_pension_at_gmp_age += gmp_step_up;

                let xs_at_gmp_age = retirement_pension_at_gmp_age - gmp_gmpDate / notional_increases;
                let pre88gmp_at_gmp_age = state.user.pre_6_april_1988_guaranteed_minimum_pension_at_gmp_age_inc_tv_in_gmp / notional_increases;
                let post88gmp_at_gmp_age = state.user.post_5_april_1988_guaranteed_minimum_pension_at_gmp_age_inc_tv_in_gmp / notional_increases;
                let xs_at_ret_age = xs_at_gmp_age * rfs.rf_ret_age / rfs.rf_gmp;
                let pre88gmp_at_ret_age = pre88gmp_at_gmp_age * Math.pow(1 + gmpLRF - assumptions.inflation,  y_days(gmp_date, dor));
                let post88gmp_at_ret_age = post88gmp_at_gmp_age * Math.pow(1 + gmpLRF,  y_days(gmp_date, dor));

                retirement_pension = xs_at_ret_age + pre88gmp_at_ret_age + post88gmp_at_ret_age;
                gmp_dor = pre88gmp_at_ret_age + post88gmp_at_ret_age;

            } else {
                retirement_pension = (retAge <=60 ?
                    interpolate([state.user.immediate_pension_unred, state.user.pension_at_60_unred], ageNow, 60, retAge) :
                    interpolate([state.user.pension_at_60_unred, state.user.pension_at_65_unred], Math.max(ageNow, 60), 65, retAge)) * rfs.rf_ret_age;
            }

        } else if (retAge > gmp_age && ageNow >= gmp_age) {

            if (state.user.status == 'deferred' ) {
                let retirement_xs_pension =
                state.user.immediate_xs_gmp / rfs.rf_pen_age * rfs.rf_ret_age;

                let weeksToRet = weeksFromAgeToAge(ageNow, retAge);

                let retirement_gmp_factor = 1 / 700 * weeksToRet;

                let retirement_gmp = (state.user.immediate_pre88_gmp + state.user.immediate_post88_gmp ) * (1 + retirement_gmp_factor);

                retirement_pension = retirement_xs_pension + retirement_gmp;

                gmp_dor = retirement_gmp;

                gmp_step_up = 0;
                gmp_step_up_at_gmp_age = 0;

            } else {
                retirement_pension = (retAge <=60 ?
                    interpolate([state.user.immediate_pension_unred, state.user.pension_at_60_unred], ageNow, 60, retAge) :
                    interpolate([state.user.pension_at_60_unred, state.user.pension_at_65_unred], Math.max(ageNow, 60), 65, retAge)) * rfs.rf_ret_age;
            }

        } else {
            retirement_pension = (retAge <=60 ?
                interpolate([state.user.immediate_pension_unred, state.user.pension_at_60_unred], ageNow, 60, retAge) :
                interpolate([state.user.pension_at_60_unred, state.user.pension_at_65_unred], Math.max(ageNow, 60), 65, retAge)) * rfs.rf_ret_age;

            // todays money
            gmp_dor = gmp_dol * (retirement_pension / Math.min(rfs.rf_ret_age, 1)) / (state.user.total_deferred_pension_at_dol);

            //gmp step up
            if (state.user.status == 'deferred' ) {
                let gmp_gmpDate = state.user.pre_6_april_1988_guaranteed_minimum_pension_at_gmp_age_inc_tv_in_gmp + state.user.post_5_april_1988_guaranteed_minimum_pension_at_gmp_age_inc_tv_in_gmp;
                let notional_increases = Math.pow(1+assumptions.inflation,  y_days(state.user.calculation_date, gmp_date));
                // if (state.user.pre86) {
                //     gmp_step_up =Math.max(Math.max(gmp_gmpDate - retirement_pension*notional_increases) / notional_increases,0);
                // } else {

                // }
                let notional_gmp_gmpDate = gmp_dor * notional_increases;
                // let gmp_gmpDateReal = gmp_gmpDate / notional_increases;
                gmp_step_up =Math.max(Math.max(gmp_gmpDate - notional_gmp_gmpDate) / notional_increases,0);
            }

            if (retAge == gmp_age) {
                gmp_step_up_at_gmp_age = 0;
            } else {
                gmp_step_up_at_gmp_age = gmp_step_up;
                gmp_step_up = 0;
            }

            retirement_pension += gmp_step_up;
            gmp_dor += gmp_step_up;
        }

        if (ageNow <= gmp_age & nra >= gmp_age) {
            nra_retirement_pension += gmp_step_up;
        }


        retirement_pension = Math.max(gmp_dor, retirement_pension);

        let spa = Math.max(retAge, sex == "M"? get_factor(spa_M, spa_min, spa_max, dob_months(state.user.date_of_birth) ) : get_factor(spa_F, spa_min, spa_max, dob_months(state.user.date_of_birth) ));
        let spd = state.user.date_of_birth.clone().add(spa, 'years');
        let spd_term = spd > dor ? y_days(spd, dor) : 0;

        let f_A2 = get_factor(Factor_A2, Factor_A2_min, Factor_A2_max, spd_term);
        let f_B = get_factor(Factor_B, Factor_B_min, Factor_B_max, retAge);

        // let avcCondition = mp_avcs >= 20 / 3 * (retirement_pension -((ageNow < gmp_age & retAge >= gmp_age)? gmp_step_up : 0));
        // let max_LS = avcCondition ?
        //     (5 * (retirement_pension - ((ageNow < gmp_age & retAge >= gmp_age)? gmp_step_up : 0)) + 0.25 * mp_avcs) :
        //     (f_B / (1+0.15*f_B) * ((retirement_pension - ((ageNow < gmp_age & retAge >= gmp_age)? gmp_step_up : 0)) + mp_avcs / f_B));

        let avcCondition = mp_avcs >= 20 / 3 * retirement_pension;
        let max_LS = avcCondition ?
            (5 * retirement_pension + 0.25 * mp_avcs) :
            (f_B / (1+0.15*f_B) * ((retirement_pension) + mp_avcs / f_B));

        let res_scaled_pension = avcCondition ? retirement_pension :
            retirement_pension - (max_LS - mp_avcs) / f_B;
        let min_res_pension = Math.max(res_scaled_pension, gmp_dor);

        max_LS = avcCondition ? max_LS :
            mp_avcs + (retirement_pension - min_res_pension) * f_B


        max_LS = Math.min(max_LS, 0.25 * lta);

        //test for GMP


        //before GMP test
        let cash_taken = max_LS > mp_avcs? cashProp * (max_LS - mp_avcs) + mp_avcs : max_LS;
        let cash_from_avcs = Math.min(cash_taken, mp_avcs);
        let cash_from_pension = cash_taken - cash_from_avcs;
        let pension_commuted = cash_from_pension / f_B;
        let pension_post_comm = retirement_pension - pension_commuted;

        //test for gmp
        //let gmpTest = gmp_dor + retAge >= gmp_age? gmp_step_up : 0;
        // let residual_safe = Math.max(pension_post_comm, gmp_dor);
        // let commuted_safe = Math.max(retirement_pension, gmp_dor) - residual_safe;
        // let LS_safe = avcCondition? cash_taken : cash_from_avcs + commuted_safe * f_B;
        let remaining_avc = Math.max(mp_avcs - cash_taken,0);

        //spouses pension
        // let sp_prop = state.user.status == 'deferred'? state.user.total_spouses_pension_at_dol / state.user.total_deferred_pension_at_dol : state.user.immediate_sp_pension / state.user.immediate_pension_unred;
        let retirement_sp_pen = state.user.immediate_sp_pension;
        if(state.user.status != 'deferred') {
            retirement_sp_pen = retirement_sp_pen * (retirement_pension / rfs.rf_ret_age)  / state.user.immediate_pension_unred
        }

        let bridge = 0;
        let post_bridge_reduction = 0;
        //bridge the gap
        if (retAge <= spa) {
            let bsp_test = Math.min(bsp, (pension_post_comm - gmp_dor) / (1- f_A2) );
            bridge = bsp_test * f_A2;
            post_bridge_reduction = bsp_test;
        }



        return {
            nra: nra,
            nra_retirement_pension: nra_retirement_pension,
            retirement_age: retAge,
            retirement_pension: pension_post_comm + (bridgeTheGap? bridge : 0),
            retirement_pension_with_bridge: pension_post_comm + bridge,
            retirement_pension_no_bridge: pension_post_comm,
            retirement_pcls: cash_taken,
            pension_used_in_commutation: pension_commuted,
            avcs_used_in_commutation: cash_from_avcs,
            retirement_residual_avcs: remaining_avc,
            retirement_sp_pen: retirement_sp_pen,
            gmp_age: gmp_age,
            gmp_step_up: gmp_step_up_at_gmp_age,
            gmp_step_up_applied: gmp_step_up,
            spa: spa,
            bridging_addition: bridge,
            post_bridge_reduction: post_bridge_reduction
        };
    },
    getAnnuityCalc: function (state, cashProp, increasing, spouse, smoker, chronic) {
        if (!state.user) return null;

        let tv = getProjectedTV(state);
        let retAge = state.retirementAge;

        let max_LS = Math.min(0.25 * tv, 0.25 * lta);

        let pcls =  cashProp * max_LS;

        let residual_tv = tv - pcls;

        return {
            doc_age: state.user.age,
            doc_tv: state.user.transfer_value_use,
            retirement_age: retAge,
            retirement_tv: tv,
            retirement_pcls: pcls,
            retirement_pcls_as_pension:  pcls / get_annuity(retAge, spouse, increasing, smoker, chronic),
            retirement_annuity: residual_tv / get_annuity(retAge, spouse, increasing, smoker, chronic),
            retirement_annuity_increasing: residual_tv / get_annuity(retAge, spouse, true, smoker, chronic),
            retirement_annuity_non_increasing: residual_tv / get_annuity(retAge, spouse, false, smoker, chronic),
            retirement_annuity_spouse: residual_tv / get_annuity(retAge, true, increasing, smoker, chronic),
            retirement_annuity_no_spouse: residual_tv / get_annuity(retAge, false, increasing, smoker, chronic),
            retirement_sp_pen: spouse?  residual_tv / get_annuity(retAge, spouse, increasing, smoker, chronic) * 0.66 : 0
        };

    },
    getDrawdownCalc: function (state, cashProp, taxedCashProp, dd_age) {
        if (!state.user) return null;

        let tv = getProjectedTV(state);
        let retAge = state.retirementAge;

        let max_LS = Math.min(0.25 * tv, 0.25 * lta);

        let pcls =  cashProp * max_LS;

        let residual_tv = tv - pcls;

        let taxedCash = cashProp == 1? taxedCashProp * residual_tv : 0;

        residual_tv -= taxedCash;

        let annuity_factor = getDrawdownAnnuity(retAge, dd_age);
        let annuity = Math.max(residual_tv / annuity_factor - assumptions.dd_annual_cost,0);

        let life_expectancy = lifeexpectancy[state.user.sex + "_" + state.user.category][Math.max(Math.min(Math.floor(state.user.ageNow),lifeexpectancy_age_max),lifeexpectancy_age_min)  - lifeexpectancy_age_min][state.user.yob- lifeexpectancy_yob_min];

        return {
            doc_age: state.user.age,
            doc_tv: state.user.transfer_value_use,
            retirement_age: retAge,
            retirement_tv: tv,
            retirement_pcls: pcls + taxedCash,
            retirement_pcls_commuted: ( pcls + taxedCash) / annuity_factor,
            retirement_pcls_tax_free: pcls,
            retirement_pcls_taxed: taxedCash,
            retirement_pcls_approx_tax: caclculateTax(taxedCash),
            retirement_pcls_tax_free_commuted: pcls / annuity_factor,
            retirement_pcls_taxed_commuted: taxedCash / annuity_factor,
            retirement_dd_pension: annuity,
            life_expectancy: life_expectancy
        };
    }
};


export default {
    initialiseUser: initialiseUser,
    pensionFn: pensionFn,
    version: version
};
